import {
  ButtonArrowState,
  Modal,
  TertiaryButton,
  Markdown,
} from '@huggg/react-components';
import NewTabLink from 'assets/img/icons/newTabLink.svg';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import { VirtualCardRestrictionDiagram } from '../../../../../ui/PrepaidCard/VirtualCardRestrictionDiagram';
import styles from './prepaidCard.module.scss';

const CardRestrictionModal = ({ onClose, helpLinkToShow, isHeatingCard }) => {
  return (
    <Modal
      title={dictionary.prepaidCards.labels.howCanIUseThisCard}
      onClose={onClose}
      className={styles.cardRestrictionsModal}
    >
      <div className={styles.cardRestrictionsModalContent}>
        <p className={styles.semiBold}>
          {dictionary.prepaidCards.copy.usageHeader}
        </p>
        <VirtualCardRestrictionDiagram />
        <p>{dictionary.prepaidCards.copy.usageDescription}</p>
        {isHeatingCard && (
          <Markdown
            value={dictionary.prepaidCards.copy.heatingOilAdditionalInfo}
          />
        )}
        <div>
          {helpLinkToShow === 'energy' && (
            <a
              className={styles.externalLink}
              href={dictionary.prepaidCards.links.energyCardHelp}
              target="_blank"
              rel="noopener noreferrer"
            >
              {dictionary.prepaidCards.labels.energyCardHelpLabel}
              <img src={NewTabLink} alt="" />
            </a>
          )}

          {helpLinkToShow === 'water' && (
            <a
              className={styles.externalLink}
              href={dictionary.prepaidCards.links.waterCardHelp}
              target="_blank"
              rel="noopener noreferrer"
            >
              {dictionary.prepaidCards.labels.waterCardHelpLabel}
              <img src={NewTabLink} alt="" />
            </a>
          )}
        </div>
        <TertiaryButton
          label={dictionary.prepaidCards.labels.closeThisWindow}
          onClick={onClose}
          arrow={ButtonArrowState.None}
        />
      </div>
    </Modal>
  );
};

CardRestrictionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CardRestrictionModal;
